import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';

interface UseRemovePhoneNumberProps {
  deviceId?: DeviceId;
  organizationId?: OrgId;
}

interface RemovePhoneNumberBody {}

interface RemovePhoneNumberReturn {
  success: boolean;
  error?: string;
}

const useRemovePhoneNumber = ({ deviceId, organizationId }: UseRemovePhoneNumberProps) => {
  const queryParams = new URLSearchParams({ orgid: `${organizationId}` });
  const url =
    deviceId && organizationId
      ? `${process.env.VITE_API_ROOT}/devices/${deviceId}/removenumber?${queryParams}`
      : null;

  const callback = useCallback(async () => {
    if (!url) {
      return undefined;
    }

    const result: RemovePhoneNumberReturn | undefined = await postFetcher<RemovePhoneNumberBody>({
      url,
      body: {},
    });

    return result;
  }, [url]);

  return callback;
};

export default useRemovePhoneNumber;
